import React from 'react';
import Lock from '@src/assets/svg/lock-job.inline.svg';
import { CenteredFlex } from '@src/features/common';
import { getFullUrl } from '@src/helpers/url';
import { BaseBox, Card, BaseLink, TextBox } from 'src/kit';

/**
 * Just mock for job with closed state.
 * @param slug - redirect to getFullUrl(slug, '/talent-pool/new')
 *
 */
export function ClosedJob({ slug }) {
  return (
    <Card
      position="relative"
      m="-90px auto 120px"
      p="30px 40px"
      width="836px"
      height="608px"
      bg="white"
      boxShadow="shadow1"
    >
      <CenteredFlex height="100%" flexDirection="column">
        <BaseBox as={Lock} />
        <TextBox fontSize="20px" pt={25} textAlign="center" lineHeight="20px">
          This specific job is currently closed, but
        </TextBox>
        <BaseLink fontSize="20px" pt={15} color="primary" href={getFullUrl(slug, '/talent-pool/new')}>
          please drop us your CV
        </BaseLink>
      </CenteredFlex>
    </Card>
  );
}
